<div class="flex-col mb-[50px]">
  <section class="flex w-full">
    <div
      [ngClass]="[currentScreenSize() === 'SM' ? 'mb-[25px] grid-cols-1' : 'mb-[25px] grid-cols-2', 'grid w-full']">
      <div class="flex justify-start font-['Roboto'] text-xl font-medium text-cafe sm:text-3xl">
        {{ 'components.AllSpecialCreatedProductsComponent.title' | transloco }}
      </div>

      <div [ngClass]="[currentScreenSize() === 'SM' ? 'mt-[20px] justify-start' : 'justify-end', 'flex']">
        <ln-product-filter [selectedFilter]="selectedFilter"></ln-product-filter>
      </div>
    </div>
  </section>

  <section class="flex w-full">
    <div class="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6
        gap-x-[15px] gap-y-[25px] sm:gap-x-[43px]
        items-start justify-items-stretch content-start">
      @for(product of products(); track product.productoId) {
        <ln-main-product-card [product]="product" [showPrice]=true></ln-main-product-card>
      }
    </div>
  </section>

  @if(showMoreProducts()) {
    <div class="flex w-full justify-center mt-[40px]">
      <ln-primary-button [showSpinner]="showMoreProductsButonSpinner()" [class]= "'flex w-[192px] items-center h-[48px] bg-[#577778] text-base font-semibold text-white/90 rounded-md justify-center'" (OnClick)="getMoreProducts()" [label] = "'buttons.seeMoreProducts' | transloco"></ln-primary-button>
    </div>

  }
</div>



